import throttle from 'lodash/throttle'
import Flickity from 'flickity'
import 'flickity-sync'
import 'flickity-fade'
import 'flickity/dist/flickity.css'
import 'flickity-fade/flickity-fade.css'

const ARROW_SHAPE = 'M36.06 87.343c1.507 1.543 4.006 1.543 5.566 0 1.503-1.496 1.503-3.974 0-5.47L13.41 53.892h82.686c2.174 0 3.905-1.717 3.905-3.874 0-2.138-1.731-3.92-3.905-3.92H13.409l28.217-27.919c1.503-1.547 1.503-4.043 0-5.52-1.56-1.544-4.059-1.544-5.566 0L1.167 47.265c-1.556 1.495-1.556 3.973 0 5.451L36.06 87.343z'

export const SLIDER_DEFAULTS = {
  autoPlay: 8000,
  adaptiveHeight: true,
  cellAlign: 'left',
  arrowShape: ARROW_SHAPE,
  lazyLoad: true,
  fade: true
}

const SELECTORS = Selectors({
  slider: '[data-slider]',
  sliderNavTop: 'slider--nav-top',
  sliderDots: 'flickity-page-dots'
})

const props = {
  $sliders: document.querySelectorAll(SELECTORS.slider)
}

const fn = {
  init: () => {
    const bgImageOpts = Object.assign({}, SLIDER_DEFAULTS, {
      prevNextButtons: false,
      setGallerySize: false
    })

    props.$sliders.forEach(($el) => {
      let opts = Object.assign({}, SLIDER_DEFAULTS)

      if ($el.dataset.slider === 'bg-image') {
        opts = bgImageOpts
      }

      if ($el.dataset.slider === 'grouped') {
        opts = fn.handleGroupCells(opts)
      } else {
        opts.wrapAround = true
      }

      if ($el.dataset.sliderAutoplay) {
        opts.autoPlay = false
      }

      if ($el.dataset.sliderSlide) {
        opts.fade = false
      }

      fn.setupSlider($el, opts)
    })

    fn.bindEvents()

    setTimeout(fn.handleResize, 500)
  },

  bindEvents: () => {
    window.addEventListener('resize', throttle(fn.handleResize, 250))
  },

  handleResize: () => {
    props.$sliders.forEach(($el) => {
      const slider = Flickity.data($el)

      if ($el.dataset.slider === 'grouped') {
        slider.options = fn.handleGroupCells(slider.options)
      }

      slider.resize()
      slider.reposition()
    })
  },

  handleGroupCells: (_opts) => {
    let opts = Object.assign({}, _opts)
    opts.groupCells = undefined
    opts.fade = false

    if (window.matchMedia('(min-width: 768px)').matches) {
      opts.groupCells = '100%'
    }

    return opts
  },

  setupSlider: ($el, opts = {}) => {
    const slider = new Flickity($el, opts)

    if ($el.classList.contains(SELECTORS.sliderNavTop)) {
      const $dots = $el.querySelector(SELECTORS.asClass('sliderDots'))

      if ($dots) {
        $el.prepend($dots)
      }
    }

    fn.updateSlider(slider)

    slider.on('resize', () => {
      fn.updateSlider(slider)
    })
  },

  updateSlider: (slider) => {
    const isSingleSlide = slider.slides.length < 2
    const hasPrevNextButtons = slider.options.prevNextButtons

    slider.element.classList.toggle('is-single-slide', isSingleSlide)
    slider.element.classList.toggle('has-buttons', hasPrevNextButtons)
  }
}

export const Slider = {
  init: ($el, opts = {}) => {
    fn.setupSlider($el, opts)
  }
}

export default {
  can: () => props.$sliders.length,
  run: fn.init
}
